// extracted by mini-css-extract-plugin
export default {"input":"Input_input__+Y3GC","vertInput":"Input_vertInput__XmrcF"};